import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check if user is logged in on mount
        const storedUser = localStorage.getItem('krishna_user');
        if (storedUser) {
            const userData = JSON.parse(storedUser);
            setUser(userData);
            
            // --- Silent Auto-Cache for Existing Users ---
            // If they are already logged in but cache is missing (from old version), populate it now.
            if (!localStorage.getItem('user_first_name') && userData.name) {
                const firstName = userData.name.split(' ')[0];
                localStorage.setItem('user_first_name', firstName);
                console.log("⚡ [Auth] Silently cached first name for existing session.");
            }
            if (!localStorage.getItem('welcome_seen') && userData.has_received_welcome !== undefined) {
                localStorage.setItem('welcome_seen', userData.has_received_welcome ? 'true' : 'false');
                console.log("⚡ [Auth] Silently cached welcome status for existing session.");
            }
        }
        setLoading(false);
    }, []);

    const login = (userData) => {
        setUser(userData);
        localStorage.setItem('krishna_user', JSON.stringify(userData));
        // Cache first name and welcome status separately for optimized greeting
        if (userData) {
            if (userData.name) {
                const firstName = userData.name.split(' ')[0];
                localStorage.setItem('user_first_name', firstName);
            }
            if (userData.has_received_welcome !== undefined) {
                localStorage.setItem('welcome_seen', userData.has_received_welcome ? 'true' : 'false');
            }
        }
    };

    const logout = () => {
        setUser(null);
        localStorage.removeItem('krishna_user');
        localStorage.removeItem('user_first_name');
        localStorage.removeItem('welcome_seen');
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
